import { Component, Input, OnInit } from "@angular/core";
import { fadeInUp400ms } from "src/@vex/animations/fade-in-up.animation";
import { stagger40ms } from "src/@vex/animations/stagger.animation";
import { ItemOwnerWithRelations } from "src/app/api/models";
import { CompareService } from "src/app/shared/services/compare.service";
import { OwnerService } from "src/app/shared/services/owner.service";

@Component({
    selector: "app-item-preview-owners",
    templateUrl: "./owners.component.html",
    styleUrls: ["./owners.component.scss"],
    animations: [fadeInUp400ms, stagger40ms],
    standalone: false
})
export class ItemPreviewOwnersComponent implements OnInit {
  @Input() owners: ItemOwnerWithRelations[];
  sortedData: ItemOwnerWithRelations[];

  constructor(
    public ownerService: OwnerService,
    private compareService: CompareService
  ) {}

  ngOnInit(): void {
    this.sortedData = this.owners.sort((a, b) => {
      const isAsc = true;
      if (a.ownerType?.sortOrder === b.ownerType?.sortOrder) {
        return this.compareService.compare(
          a.yearPurchase,
          b.yearPurchase,
          !isAsc
        );
      } else {
        // Compare by ownerType.sortOrder
        return this.compareService.compare(
          a.ownerType?.sortOrder,
          b.ownerType?.sortOrder,
          isAsc
        );
      }
    });
  }
}
